import { transformPricingTiers } from "@/utils/pricing";
export const getPricingDisplay = (contract, pricingPolicy)=>{
    if (contract.pricing_terms?.aws_marketplace) {
        return {
            type: "marketplace",
            includedQuota: contract.pricing_terms.aws_marketplace.included_quota_value,
            quotaUnit: contract.pricing_terms.aws_marketplace.included_quota_unit
        };
    }
    const unit = contract.pricing_terms?.unit_of_measure || pricingPolicy?.UnitOfMeasure || "bytes";
    const currency = contract.pricing_terms?.currency || pricingPolicy?.Currency || "USD";
    const tiers = transformPricingTiers({
        contractTiers: contract.pricing_terms?.tiers,
        pricingPolicyTiers: pricingPolicy?.Tiers,
        unitOfMeasure: unit
    });
    if (tiers.length > 0) {
        return {
            type: "tiered",
            unit,
            currency,
            tiers: tiers.map((tier)=>({
                    tier: tier.tier,
                    range: tier.range,
                    price: tier.price ?? 0
                }))
        };
    }
    if (pricingPolicy?.FixedPrice) {
        return {
            type: "fixed",
            unit,
            currency,
            price: pricingPolicy.FixedPrice
        };
    }
    return null;
};
